/* 布局 */
//前台
import Layout from "@views/layout";

const showdocRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "showdoc/list",
        name: "SHOWDOC",
        meta: {
            title: "api接口文档",
            keepAlive:true
        },
        component: () => import("@views/business/showdoc/index.vue"),
    },
        ],
};

export default showdocRouter;
